import { render, staticRenderFns } from "./dataLabelManagement.vue?vue&type=template&id=c9c99c26&scoped=true"
import script from "./dataLabelManagement.vue?vue&type=script&lang=js"
export * from "./dataLabelManagement.vue?vue&type=script&lang=js"
import style0 from "./dataLabelManagement.vue?vue&type=style&index=0&id=c9c99c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c99c26",
  null
  
)

export default component.exports